if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

           var selectedStore = localStorage.getItem('selected-store-id');
          var quantityAtLocation = 0;

           this.querySelectorAll('[data-js-location]').forEach(elm => {
              if (selectedStore === elm.id) {
                quantityAtLocation = elm.innerText;
              }
            })

          var ignoreInventory = this.querySelectorAll('[data-js-ignore-inventory]').length > 0;
          if (ignoreInventory) {
            quantityAtLocation = 999;
          }

          console.log('qty at location ' + quantityAtLocation)
			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
                        input = this.querySelector('.qty-selector'),
						qtyMin = 1,
						qtyMax = quantityAtLocation;

			if ( parseInt(qty.value) - 1 < qtyMin ) {
              qty.value = qtyMin;
          
				qtyMinus.classList.add('disabled');
			}
			if ( parseInt(qty.value) + 1 > qtyMax ) {
                qty.value = qtyMax;
        
				qtyPlus.classList.add('disabled');
			}

           input.addEventListener('change', (e)=>{
				e.preventDefault();
				if (input.valueAsNumber > qtyMax) {
                  input.valueAsNumber = qtyMax;
                }
			});

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyMinus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty - 1 >= qtyMin ) {
						qty.value = currentQty - 1;
						qtyPlus.classList.remove('disabled');
					} 
					if ( currentQty - 1 <= qtyMin ) {
                      qtyMin = qtyMin;
						qtyMinus.classList.add('disabled');
					}
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				if ( ! qtyPlus.classList.contains('disabled') ) {
					const currentQty = parseInt(qty.value);
					if ( currentQty + 1 <= qtyMax ) {
						qty.value = currentQty + 1;
						qtyMinus.classList.remove('disabled');
					} 
					if ( currentQty + 1 >= qtyMax ) {
                        qty.value = qtyMax;
						qtyPlus.classList.add('disabled');
					}
				}
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
}

}